// extracted by mini-css-extract-plugin
export var card = "_9b-0";
export var failedIcon = "_9b-4";
export var failedIconBadge = "_9b-3";
export var icon = "_9b-1";
export var successIcon = "_9b-2";